import { inject, makeEnvironmentProviders, provideEnvironmentInitializer } from '@angular/core';
import { UserStore } from '../store/user.store';
import { UserFacade } from '../facade/user.facade';

export function provideUser() {
  return makeEnvironmentProviders([
    UserStore,
    UserFacade,
    // Signal stores are created lazily on first injection — but this store's reducers
    // must already be registered when early events fire (tenant bridges dispatch
    // loadUserSuccess during app init, long before any component injects UserFacade).
    provideEnvironmentInitializer(() => inject(UserStore)),
  ]);
}
